import { useEffect } from 'react'
import * as store from '@store'
import { useWireValue } from '@forminator/react-wire'
import { RT_EVENT_TYPE_UNLOCK_RUNSHEET } from '@/constants/realtime'
import * as actions from '@actions'

export const useRealtimeRunsheetLock = runsheetDocumentJoinIds => {
    const notifications = useWireValue(store.notifications)
    const remoteConfig = useWireValue(store.remoteConfig)
    
    const getEnhancedValues = async rdjId => {
        await actions.getEnhancedValues(rdjId)
    }
    
    useEffect(() => {
        
        if (!remoteConfig?.realtimeEnabled) return
        if (!runsheetDocumentJoinIds?.length) return
        
        const latestNotification = notifications
            .filter(
                notification =>
                    notification.message.data.type === RT_EVENT_TYPE_UNLOCK_RUNSHEET &&
                runsheetDocumentJoinIds.includes(notification.message.data.data.rdjId),
            )
            .sort((a, b) => new Date(b.message.data.data.createdAt) - new Date(a.message.data.data.createdAt))[0]
        
        if (!latestNotification) return
        
        getEnhancedValues(latestNotification.message.data.data.rdjId)
        
    }, [notifications])
    
}
